<fw-listbox-base [PropertyName]="PropertyName"
                 [LFFLookupTable]="LFFLookupTable"
                 [FormEditStyle]="FormEditStyle"
                 [HeaderLabel]="HeaderLabel"
                 [CustomFormGroup]="CustomFormGroup">
</fw-listbox-base>